export default __webpack_public_path__ + "static/media/crvFRAX.e0dd0a85.svg";